import { http, toFormData, getCsrfToken } from './index';

export type DiscountPayload = {
  product_ids: number[];
  gateways: number[];
  code: string;
  quantity: number;
};

export type ProductDiscount = {
  price: string;
  price_usd: string;
  price_value: number;
  currency: string;
  currency_code: string;
  price_month: number;
  discount_sum: string;
  discount_value: number;
  discount_percent: string;
};

export enum DISCOUNT_STATUS {
  error = 0,
  success = 1,
}

type DiscountMerchantData =
  | {
      status: DISCOUNT_STATUS.error;
      error: string;
    }
  | {
      status: DISCOUNT_STATUS.success;
      info: ProductDiscount;
    };

type GatewayId = number;
type DiscountProductData =
  | {
      status: DISCOUNT_STATUS.error;
      error: string;
    }
  | {
      status: DISCOUNT_STATUS.success;
      gateways: Record<GatewayId, DiscountMerchantData>;
    };

type ProductId = number;
type DiscountResponseError = {
  code: {
    status: DISCOUNT_STATUS.error;
    value: string;
    error: string;
  };
  products: never;
};

export type DiscountResponseSuccess = {
  code: {
    status: DISCOUNT_STATUS.success;
    value: string;
  };
  products: Record<ProductId, DiscountProductData>;
};

export type DiscountResponse = DiscountResponseError | DiscountResponseSuccess;

export async function checkDiscountRedeem(
  params: DiscountPayload,
): Promise<DiscountResponse> {
  const locParams = Object.entries(params).reduce(
    (acc, [key, value]) => {
      acc[key] = value.toString();
      return acc;
    },
    {} as Record<string, string>,
  );

  return http<DiscountResponse>({
    method: 'POST',
    url: '/pricing/check-discount-redeem/',
    data: toFormData({
      ...locParams,
      ...getCsrfToken(),
    }),
  });
}
